import moment, { Moment } from 'moment-timezone';
import { SalesDashboardFilters } from 'model/salesDashboard';
import { FilterOption } from '../types/DashboardTypes';

export const getDatesForYearFilter = (yearFilterVal: string): { startDate: Moment; endDate: Moment } => {
    switch (yearFilterVal) {
        case 'last-year':
            return {
                startDate: moment().subtract(1, 'year').startOf('year'),
                endDate: moment().subtract(1, 'year').endOf('year')
            };
        case 'last-6-months':
            return {
                startDate: moment().subtract(6, 'months'),
                endDate: moment()
            };
        case 'last-3-months':
            return {
                startDate: moment().subtract(3, 'months'),
                endDate: moment()
            };
        case 'ytd':
        default:
            return {
                startDate: moment().startOf('year'),
                endDate: moment()
            };
    }
};

export const getDatesForComparisonFilter = (
    comparisonFilterVal: string,
    startDate: Moment,
    endDate: Moment
): { compareStartDate: Moment; compareEndDate: Moment } => {
    // Determine the difference to subtract based on the current filter
    // Standard is typically "last year in the same period" for comparing YTD or specific dates.
    // However, if comparisonFilterVal is specifically selecting a previous relative period
    // we can calculate based on it.
    // For now we assume comparing to the same period 1 year prior if 'last-year' comparison
    // or same duration before the startDate.
    const duration = moment.duration(endDate.diff(startDate));

    if (comparisonFilterVal === 'previous-period') {
        return {
            compareStartDate: moment(startDate).subtract(duration),
            compareEndDate: moment(startDate).subtract(1, 'ms')
        };
    }

    // Default to last year same period
    return {
        compareStartDate: moment(startDate).subtract(1, 'year'),
        compareEndDate: moment(endDate).subtract(1, 'year')
    };
};

export const getComparisonOptionsForYear = (yearFilterVal: string): FilterOption[] => {
    switch (yearFilterVal) {
        case 'last-year':
            return [{ id: 'previous-year', name: 'Previous year (2 years ago)' }];
        case 'last-6-months':
        case 'last-3-months':
            return [
                { id: 'previous-period', name: 'Previous period' },
                { id: 'last-year', name: 'Same period last year' }
            ];
        case 'ytd':
        default:
            return [{ id: 'last-year', name: 'Year to date last year' }];
    }
};
